// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_Z58","cls2":"Base-cls2_lAL Base-cls1_Z58"};